module.exports = __webpack_public_path__ + "img/wallet_02_fiat_1.978a826a.png";